module.exports = __webpack_public_path__ + "img/calendar.3dbc1e5a.svg";